import { render, staticRenderFns } from "./GlobalAlertLayout.vue?vue&type=template&id=6f9ec1dd&scoped=true&"
import script from "./GlobalAlertLayout.vue?vue&type=script&lang=js&"
export * from "./GlobalAlertLayout.vue?vue&type=script&lang=js&"
import style0 from "./GlobalAlertLayout.vue?vue&type=style&index=0&id=6f9ec1dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9ec1dd",
  null
  
)

export default component.exports